import React, { memo } from "react"
import * as styles from "../../page_css/page.css"
import Layout from "../../components/layout"
import { PageProps } from "../../types"
import PageHero from "../../components/page-hero"
import * as blocks from "../../components/blocks"
import Fallback from "../../components/fallback"
import { useLocation } from '@reach/router';

export default function Full(props: PageProps) {
  const { page } = props.data
  const background = page.pageBackground ? {
    image: page.pageBackground,
    overlayColor: page.backgroundOverlayColor || null,
    overlayOpacity: page.backgroundOverlayOpacity || null,
  } : null
  const heroImage = page.heroImage? {
    image: page.heroImage,
    overlayColor: page.heroOverlayColor || null,
    overlayOpacity: page.heroOverlayOpacity || null,
  } : null

  const allContent = page.content?.map((block) => {
    const { id, blocktype, desktopRight, displayFullWidth, ...componentProps } = block
    const Component = memo(blocks[blocktype] || Fallback)
    return <Component key={id} id={id} blocktype={blocktype} displayFullWidth={displayFullWidth} {...(componentProps as any)} />
  })
  const location = useLocation(); // Get current location
  const currentPath = location.pathname; // Current path

  return (
    <Layout background={background} location={currentPath}>
      <PageHero title={page.title} subtitle={page.subtitle} {...heroImage} hidePageTitle={page?.hidePageTitle} />
      <div className={`${styles.pageContainer} fullpage`}>
        {allContent?.map((block) => {
          return (block)
          } 
        )}
      </div>
    </Layout>
  )
}